// material-ui
import { alpha, createTheme } from '@mui/material/styles'
import { PaletteMode } from '@mui/material'

// project-imports
import ThemeOption from './theme'

// types
import { PaletteThemeProps } from 'types/theme'
import { PresetColor } from 'types/config'

// ==============================|| DEFAULT THEME - PALETTE  ||============================== //

const Palette = (
	mode: PaletteMode,
	presetColor: PresetColor,
	themeContrast: boolean
) => {
	const paletteColor: PaletteThemeProps = ThemeOption(presetColor, mode)

	return createTheme({
		palette: {
			mode,
			common: {
				black: '#000',
				white: '#fff',
			},
			...paletteColor,
			text: {
				primary:
					mode === 'dark'
						? '#f4f4f5' // zinc-100
						: paletteColor.secondary[800],
				secondary:
					mode === 'dark'
						? '#a1a1aa' // zinc-400
						: paletteColor.secondary.main,
				disabled:
					mode === 'dark'
						? '#52525b' // zinc-600
						: paletteColor.secondary[400],
			},
			action: {
				disabled: paletteColor.secondary.light,
			},
			divider:
				mode === 'dark'
					? '#27272a' // zinc-800
					: alpha(paletteColor.secondary.light!, 0.65),
			background: {
				paper: mode === 'dark' ? '#18181b' : '#fff', // zinc-900
				default: mode === 'dark' ? '#09090b' : (themeContrast ? '#fff' : paletteColor.secondary.lighter), // zinc-950
			},
		},
	})
}

export default Palette
